import useResource from 'app/hooks/useResource';

import {
  getPhotographerHourlyReport,
  setPhotogHourlyReportParams
} from 'app/actions/reports';

import {
  photogHourlyReport as resource
} from 'app/resources';

const usePhotographerHourlyReport = () => {
  return useResource({
    resource,
    getResource: getPhotographerHourlyReport,
    setResourceParams: setPhotogHourlyReportParams
  });
}

export default usePhotographerHourlyReport;
